export default {
  displayName: 'Duration Shingle Table',
  allowableParents: ['Section'],
};
